// extracted by mini-css-extract-plugin
export var acceptButton = "_2i-5";
export var fullContent = "_2i-4";
export var link = "_2i-6";
export var linkIcon = "_2i-7";
export var sideContent = "_2i-3";
export var sideImage = "_2i-2";
export var sideImageWrapper = "_2i-1";
export var splitLayout = "_2i-0";